import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { IconButton, styled } from '@mui/material';

const ExitIcon = styled(FontAwesomeIcon)({
    color: 'white',
});

const Frame = styled(IconButton)({
    width: 'fit-content',
    padding: '10px',
});

export type ExitButtonProps = {
    onClick: () => void;
};

export const ExitButton = (props: ExitButtonProps) => {
    return (
        <Frame onClick={() => props.onClick()}>
            <ExitIcon icon={faSignOutAlt} />
        </Frame>
    );
};
